import { useParams } from 'react-router-dom';
import CreateCreditDebitNote from '../CreditNotes/CreateCreditNote';

const EditDebitNote = () => {
    const { id } = useParams();
    return <CreateCreditDebitNote noteType="DEBIT_NOTE" noteId={id} />;
};

export default EditDebitNote;
